import { DocParser, findDate } from '../DocParser';

import { paymentDatesPhrases } from '../keywords';

export const getPaymentDate = (doc: string) => {
  const parser = new DocParser(doc);

  return parser.extractRelevantWord(findDate, paymentDatesPhrases, 1);
};